module.exports = __webpack_public_path__ + "static/media/highest.be96d26b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/priority/highest.svg
// module id = 247
// module chunks = 0